// extracted by mini-css-extract-plugin
export var container = "index-module--container--2bElF";
export var counter = "index-module--counter--McUwe";